var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56654 0.702107C6.80086 0.467793 7.18075 0.467793 7.41507 0.702107L10.1022 3.38922L12.9306 0.560807C13.1649 0.326492 13.5448 0.326492 13.7791 0.560807C14.0134 0.795121 14.0134 1.17502 13.7791 1.40934L10.9507 4.23774L15.759 9.04607L18.5874 6.21766C18.8218 5.98335 19.2017 5.98335 19.436 6.21766C19.6703 6.45198 19.6703 6.83187 19.436 7.06619L16.6076 9.8946L19.2945 12.5815C19.5288 12.8158 19.5288 13.1957 19.2945 13.43C19.0601 13.6643 18.6802 13.6643 18.4459 13.43L17.1732 12.1573L14.2034 15.1272C11.7689 17.5617 7.90571 17.6968 5.31272 15.5324L2.04112 18.804C1.80681 19.0383 1.42691 19.0383 1.19259 18.804C0.958278 18.5697 0.958279 18.1898 1.19259 17.9554L4.46422 14.6838C2.30003 12.0908 2.43514 8.22782 4.86955 5.79341L7.83944 2.82353L6.56654 1.55064C6.33223 1.31632 6.33223 0.936422 6.56654 0.702107ZM8.68796 3.67206L5.71808 6.64194C3.60925 8.75077 3.60925 12.1699 5.71808 14.2787C7.82691 16.3875 11.246 16.3875 13.3548 14.2787L16.3247 11.3088L15.3348 10.3189L9.67791 4.66201L8.68796 3.67206Z",
    fill: "#70797B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegration);
export default __webpack_public_path__ + "static/media/icon-integration.24aa859d2c0bd5a7069e6e41f5ddb1ec.svg";
export { ForwardRef as ReactComponent };